<template>
    <div class="invalid-feedback" style="display: block" v-if="errors && errors[field]">
        {{ errors[field][0] }}
    </div>
</template>
<script>

    export default {

        props: {
            errors: {
                type: Object | null,
                required: true
            },
            field: {
                type: String,
                required: true
            }
        }

    }

</script>
